/*/ ## EF.Collections.ResourcesCollection
//
// Collection for resources and policies associated with
// and enrollment */
var utils = require('lib/utils');
(function(EF, undefined) {

    var ResourcesCollection = Chaplin.Collection.extend({
    model: EF.Models.Resource,
    fileName: 'resources.json',
    initialize: function(models, options) {
      this.enrollment = options.enrollment;
      this.on('add', this.onAdd);
    },
    url: function() {
      return EF.url('/sdk/enrollments/' + this.enrollment.get('id') +'/' + this.fileName);
    },
    sync: function() {
      //if in local mode just do nothing
      if(EF.options.local && !EF.options.loadCustomizationsRemote) {
        return;
      }
      return Backbone.sync.apply(this, arguments);
    },
    onAdd: function(resource) {
      resource.enrollment = this.enrollment;
      this.normalize(resource);
    },
    normalize: function(resource){
      let r = JSON.parse(JSON.stringify(resource));
      if(r.attributes) r = utils.sanifyJsonApiObject(r);
      if(r.esignature) {
        r.requires_e_signature = true;
      }
      if(r.type === 'content_business_policies') {
        r.type = 'PolicyResource';
      }
      if(r.type === 'business_resource_contents') {
        r.type = 'Resource';
      }
      if(r.content && !r.body) {
        r.body = r.content;
      }
      if(r.id && r.type) {
        r.id = `${r.type}-${r.id}`;// makes the id unique since collection is of two diff mixed types
      }
      if(r.slug) {
        r.sub_type = r.slug;
      }
      if(r.media_url && !r.url) {
        r.url = r.media_url;
      }
      if (r.type === 'PolicyResource') {
        if (r.body && !r.requires_e_signature) {
          r.requires_body_view = true;
        }
        if (r.url) {
          r.requires_link_click = true;
        }
      }
      resource.attributes = r;
    },
    byType: function(type, sub_type) {
        var deferred = $.Deferred();
        var self = this;
        var resources;
        if(this.length > 0) {
          resources = self.byTypeSync(type, sub_type);
          deferred.resolve(resources);
        } else {
          EF.ContentProvider.ResourceService.loadResources().then(function() {
              resources = self.byTypeSync(type, sub_type);
              deferred.resolve(resources);
          });
        }
        return deferred.promise();
    },
    byTypeSync: function (type, subType) {
      const models = this.models;
      const filterResources = sub => models.filter(model => model.attributes.sub_type === sub);
      let resources;
      if (subType) {
        // if subType consists of multiple objects, iterate and assign props
        // otherwise filter only once
        const subTypes = Array.isArray(subType) ? subType : [subType];
        subTypes.forEach(e => {
          const thisResource = filterResources(e);
          resources = resources ? resources.concat(thisResource) : thisResource;
      })
      } else {
        // if there is no subtype and type is Resource, filter resources to not include PolicyResource type
        const isResource = type === 'Resource';
        resources = models.filter(({ attributes: { type: modelType } }) => {
          return isResource ? modelType !== 'PolicyResource' : modelType === type;
        });
      }
      return resources;
    }
  });


  _.extend(EF.Collections, {
    ResourcesCollection: ResourcesCollection
  });

})(EF);
